import { CDNImage } from '~/components/ui/CDNImage'

export function GPT4oSilent() {
  return (
    <div className="flex flex-col items-center justify-center  gap-2 mb-6">
      <CDNImage
        alt="DeepSeek"
        src="/images/deepseek/brain.svg"
        className="w-20 h-20 block mx-auto"
      />
      <div className="text-[32px] leading-[40px] font-semibold text-neutral-900">
        欢迎使用4o-image作画
      </div>
      <div className="text-neutral-500 text-sm font-semibold">
        可生成含复杂文字和细节的图片，严格遵循多对象控制指令，能处理多个物体的细节和位置
      </div>
    </div>
  )
}
